<template>
	<OnSiteMessagePopupForm
		:is-loading="isLoading"
		@onSubmit="handleSubmit"
	/>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import OnSiteMessagePopupForm from '@/components/OnSiteMessagePopupForm.vue';

import { ROUTE_NAME } from '../enums/route';
import { scrollToTop } from '../assets/js/helpers';

export default {
	name: 'OnSiteMessagePopupCreate',

	components: {
		OnSiteMessagePopupForm,
	},

	computed: {
		...mapState('onSiteMessages', {
			create: 'create',
		}),

		isLoading() {
			return this.create.isLoading;
		},
	},

	methods: {
		...mapActions({
			showToast: 'toast/showToast',
			createPopupCampaign: 'onSiteMessages/createPopupCampaign',
		}),

		async handleSubmit(data) {
			try {
				await this.createPopupCampaign(data);

				this.$router.push({ name: ROUTE_NAME.ON_SITE_MESSAGE_POPUP_LIST });
			} catch {
				scrollToTop();
			}
		},
	},
};
</script>
